/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef, useState } from 'react';
import uuid from 'uuid/v4';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CAC_CLUSTER_BY_RESPONDENTS } from '../CacConstants';
import InfoBox from '../../common/EnhancedGridFeature/InfoBox';
import infoIcon from '../../../images/insight360/info-icon_black_outline.png';

const ClusterRespondentsBlock = (props) => {
  const { checkedValue, handleClusterBySwitch } = props;
  const [dropPanels, setDropPanels] = useState([]);
  const infoBoxRef = useRef(null);

  const buildInfoBox = () => {
    const buildRow = (title, text) => {
      return (
        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: "10px" }}>
          <div style={{ fontWeight: '700', minWidth: '80px', width: "80px" }}>{title}</div>
          <div>{text}</div>
        </div>
      );
    };

    if (dropPanels.length === 0) {
      const ibp = [];
      ibp.push(
        <div className="corr-axis-popover-outer">
          {buildRow('On Column Selection:', 'Rows are insignificant to each cluster\'s composition')}
          {buildRow('On Row Selection:', 'Columns are insignificant to each cluster\'s composition')}
        </div>
      );
      setDropPanels(ibp);
    }
    return dropPanels;
  };


  return (
    <div className="cluster-radio-panel">
      <div style={{ display: 'flex', gap: '2px' }}>
        <div className="cluster-radio-panel-title">Cluster By</div>
        <div className="view-axis-tooltip">
          <InfoBox
            ref={infoBoxRef}
            Panels={buildInfoBox()}
            updatePanels={buildInfoBox}
            Positions={['top']}
            Align="start"
            InfoBoxButtonInner={
              <img className="ibox-axis-info" src={infoIcon} alt="(i)" />
            }
            containerClassName="clust-popover-clusterby-info"
          />
        </div>
      </div>
      <div className="cluster-radio-panel-body">
        {CAC_CLUSTER_BY_RESPONDENTS.map((res, i) => (
          <div key={uuid()} className="cluster-radio-btn">
            <input
              type="radio"
              className="hidden-box"
              id={res.label}
              name="clusterBy"
              checked={i === checkedValue}
              onChange={() => handleClusterBySwitch(res.key)}
            />
            <label htmlFor={res.label} className="check--label">
              <div style={{ display: 'flex' }}>
                <div>
                  <span className="check--label-box" />
                </div>
                <div
                  className={classNames('check--label-text', {
                    'check--label-text-selected': i === checkedValue,
                  })}
                >
                  {res.label}
                </div>
              </div>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

ClusterRespondentsBlock.propTypes = {
  checkedValue: PropTypes.number,
  handleClusterBySwitch: PropTypes.func,
};

export default ClusterRespondentsBlock;
